var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin } from '@capacitor/core';
export class SmsManagerPluginWeb extends WebPlugin {
    constructor() {
        super({
            name: 'SmsManager',
            platforms: ['web']
        });
        this.NOT_SUPPORTED = "ERR_PLATFORM_NOT_SUPPORTED";
    }
    send(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                reject(this.NOT_SUPPORTED);
            });
        });
    }
}
const SmsManager = new SmsManagerPluginWeb();
export { SmsManager };
// this does not work for angular. You need to register the plugin in app.component.ts again.
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(SmsManager);
//# sourceMappingURL=web.js.map